import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export default class RelationApi {
    static updateChildCustody(relationId, childCustody) {
        return RESTClient.postAuthenticated(`v2/relations/${relationId}`, {
            childCustody,
        });
    }

    static updateChildLivesAt(relationId, childLivesAt) {
        return RESTClient.postAuthenticated(`v2/relations/${relationId}`, {
            childLivesAt,
        });
    }
}
